import {useTranslation} from "react-i18next";
import '../Privacy.css'

const SpendGentlyPrivacy = () => {
    const {t} = useTranslation();
    const sections = t('privacy.spend_gently.sections', {returnObjects: true});

    return (
        <div className="privacy-container">
            <h1>{t('privacy.spend_gently.title')}</h1>

            <p className="effective-date">{t('privacy.spend_gently.last_updated')}</p>
            <p>{t('privacy.spend_gently.intro')}</p>

            {sections.map((section) => (
                <section key={section.title}>
                    <h2>{section.title}</h2>
                    {section.body && <p>{section.body}</p>}
                    {section.items && (
                        <ul>
                            {section.items.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    )}
                </section>
            ))}

            <p>develop@persnormal.com</p>
        </div>
    );
}

export default SpendGentlyPrivacy;
